import React, { useEffect, useMemo, useState } from 'react'

import './FeedPage.css'
import LiveCard from './custom-comp/LiveCard'
import LiveCardVideo from './custom-comp/LiveCardVideo'
import MultiSectionCard from './custom-comp/MultiSectionCard'
import UpcomingEvents from './custom-comp/UpcomingEvents'
import { Link, useNavigate } from 'react-router-dom'
import { useRef } from 'react';
import axios from 'axios'
import LiveCardSkeleton from './custom-comp/LiveCardSkeleton'
import FeedProfileSection from './custom-comp/FeedProfileSection'
import Clogo from "../Navbar/image/logo2.svg"
import FooterAppDownloadModal from './custom-comp/FooterAppDownloadModal'
import BottomFooterModal from './custom-comp/BottomFooterModal'
import { CiSearch } from "react-icons/ci";


import { API_BASE_URL } from "../utils";
import UpcomingPlanModal from './custom-comp/UpcomingPlanModal'
import FeedHorizontalScroll from './custom-comp/FeedHorizontalScroll'

export default function FeedPage() {


  const url = `${API_BASE_URL}/master/assets/uploads/`;

  const [categories, setCategories] = useState([]);
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const categoriesApiUrl = `${API_BASE_URL}/master/Api/getData/eventCategory`;
  const allEventsApiUrl = `${API_BASE_URL}/master/APIs/ClubEvent/allEvents`;

  const categoryWiseEventsApiUrl = `${API_BASE_URL}/master/APIs/ClubEvent/categoryWiseAllEvents`;

  useEffect(() => {
    fetch(categoriesApiUrl)
      .then((response) => response.json())
      .then((data) => {
        setCategories(data.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLatitude(latitude.toString());
          setLongitude(longitude.toString());
          fetchAllEvents(latitude, longitude);
        },
        (error) => {
          alert("Please enable Geo Location Service to find events in your locality.");
          console.error('Error in finding location: ', error);
        }
      );
    } else {
      console.error("Geolocation is not available in this browser.");
    }
  }, []);
  const fetchAllEvents = (latitude, longitude) => {
    const formData = new FormData();
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    setIsLoading(true);
    fetch(allEventsApiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.status === true) {
          setEvents(data.data);
        } else {
          setEvents([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching all events:", error);
      });
  };
  const fetchEventsByCategory = (latitude, longitude, categoryId) => {
    const formData = new FormData();
    formData.append("category_id", categoryId);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    setIsLoading(true);
    fetch(categoryWiseEventsApiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.status === true) {
          setEvents(data.data);
        } else {
          setEvents([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching events by category:", error);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [data, setData] = useState([]);
  const fetchURL = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/master/APIs/Common/getWebPromotionalBanner`);
      setData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchURL();
  }, []);
  const eventUrl = (e) => {
    return `/${(e.cityName?.replace(/ /g, "-") || "").toLowerCase()}/${(e.areaName?.replace(/ /g, "-") || "").toLowerCase()}/${(e.clubName?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}/event/${(e.name?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}`;
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    if (value) {
      window.location.href = value;
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  const [visibleCount, setVisibleCount] = useState(6);
  const loaderRef = useRef(null);


  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisibleCount((prev) => prev + 6); // Load next 6
        }
      },
      { threshold: 1 }
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) observer.unobserve(loaderRef.current);
    };
  }, []);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLead, setSelecteLead] = useState(null);

  const slicedEvents = events.slice(0, visibleCount);

  const insertIndexesRef = useRef([]);

  useEffect(() => {
    if (slicedEvents.length >= 6) {
      const indexes = new Set();
      while (indexes.size < Math.min(3, slicedEvents.length - 2)) {
        const idx = Math.floor(Math.random() * (slicedEvents.length - 2)) + 1;
        indexes.add(idx);
      }
      insertIndexesRef.current = [...indexes];
    }
  }, [slicedEvents.length]);

  const upcomingRef = useRef(null);
  const [offsetTop, setOffsetTop] = useState(0);



  useEffect(() => {
    if (!upcomingRef.current) return;

    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        setOffsetTop(entry.contentRect.height); // updates height on any change
      }
    });

    observer.observe(upcomingRef.current);

    return () => {
      observer.disconnect(); // clean up on unmount
    };
  }, []);



  return (
    <div className='feed-page'>
      <div className='live-reel-container'>

        <div className='feed-page-pro-section'>
          <FeedProfileSection />
        </div>

        <div className='live-reel-header'>
          <div className='live-reel'>
            {slicedEvents.length === 0 ? (
              Array.from({ length: 4 }).map((_, i) => (
                <LiveCardSkeleton />
              ))
            ) : (
              slicedEvents.map((item, index) => (
                <React.Fragment key={item.id || index}>
                  {insertIndexesRef.current.includes(index) && (
                    <div className="available-packages-box">
                      <FeedHorizontalScroll />
                    </div>
                  )}
                  <div className="reel-item">
                    <Link to={eventUrl(item)}>
                      {item.video ? (
                        <LiveCardVideo data={item} />
                      ) : (
                        <LiveCard data={item} />
                      )}
                    </Link>
                  </div>
                </React.Fragment>
              ))
            )}


            <div ref={loaderRef} style={{ height: "1px" }} />
          </div>

        </div>

        <div className='f-upcoming-events-section' style={{ position: 'sticky', top: `${-offsetTop + 50}px`, zIndex: 2 }}>
          <div ref={upcomingRef} style={{ display: 'block', width: '100%' }}>
            <UpcomingEvents setModalOpen={setModalOpen} setSelecteLead={setSelecteLead} />
          </div>
          <div className='fues-footer-sec-line' >
            <div className='fues-footer-sec-line-f-line'>
              <div className='fues-footer-sec-line-f-text'></div>
              <div className='fues-footer-sec-line-f-text'></div>
            </div>
            <div className='fues-footer-sec-line-f-links'>

              <a href="https://www.partywitty.com/party-witty-aboutus">
                <div className='fues-footer-sec-line-f-text-content'>About us</div>
              </a>

              <a className='f-link-a' href="https://www.partywitty.com/services">
                <div className='fues-footer-sec-line-f-text-content'>services</div>
              </a>

              <div className='fues-footer-sec-line-f-text-content'>
                <select
                  id="collections-select-c"
                  name="Collections"
                  className="fues-footer-select"
                  onChange={handleSelectChange}
                  defaultValue=""
                >
                  <option value="" disabled hidden>
                    Collections
                  </option>
                  <option className='fues-footer-option' value="https://www.partywitty.com/party-packages-delhi-ncr-view-all">Packages</option>
                  <option className='fues-footer-option' value="https://www.partywitty.com/book-a-table-delhi-ncr-view-all">Venues</option>
                  <option className='fues-footer-option' value="https://www.partywitty.com/event-delhi-ncr-view-all">Events</option>
                  <option className='fues-footer-option' value="https://www.partywitty.com/artist-view-all">Artists</option>
                </select>
              </div>


              <div className='fues-footer-sec-line-f-text-content'>
                <select
                  id="collections-select-a"
                  name="Collections"
                  className="fues-footer-select"
                  onChange={handleSelectChange}
                  defaultValue=""
                >
                  <option value="" disabled hidden>
                    Agreements
                  </option>
                  <option className='fues-footer-option' value="https://www.partywitty.com/club-agreement">Club Agreement</option>
                  <option className='fues-footer-option' value="https://www.partywitty.com/artist-agreement">artist agreement</option>
                  <option className='fues-footer-option' value="https://www.partywitty.com/refund-policy">refund & cancellation policy</option>
                  <option className='fues-footer-option' value="https://www.partywitty.com/privacy-policy">privacy policy</option>
                  <option className='fues-footer-option' value="https://www.partywitty.com/term-conditions-policy">terms & conditions</option>
                </select>
              </div>

              <div className='fues-footer-sec-line-f-text-content'>
                <select
                  id="collections-select-p"
                  name="Collections"
                  className="fues-footer-select"
                  onChange={handleSelectChange}
                  defaultValue=""
                >
                  <option value="" disabled hidden>
                    Partner with
                  </option>
                  <option className='fues-footer-option' value="https://www.partywitty.com/as-an-artist">as an artist</option>
                  <option className='fues-footer-option' value="https://www.partywitty.com/Product-Pricing">as a business</option>
                </select>
              </div>

              <a className='f-link-a' href="https://www.partywitty.com/blog">
                <div className='fues-footer-sec-line-f-text-content'>blogs</div>
              </a>
              <a className='f-link-a' href="https://www.partywitty.com/our-contact-page">
                <div className='fues-footer-sec-line-f-text-content'> Contact us</div>
              </a>
              <div className='fues-footer-sec-line-f-text-content' onClick={() => setShowModal(true)}> Get the app</div>
              <div className='fues-footer-sec-line-f-text-content' onClick={() => setIsModalOpen(true)}>more</div>

            </div>
            <div className='fues-footer-sec-line-f-logo-copywrite'>
              <div className='fues-footer-sec-line-f-logo'>
                <img src={Clogo} alt="" />
              </div>
              <p> AMIRAG HOSPITALITY PVT. LTD © 2025</p>
            </div>
          </div>
        </div>
      </div>

      <FooterAppDownloadModal isOpen={showModal} onClose={() => setShowModal(false)} />
      <BottomFooterModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <UpcomingPlanModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        selectedLead={selectedLead}
      />
    </div >
  )
}
